import React from 'react';
import { useI18n } from '@oneaudi/i18n-context';
import { SYS_SPACE_FIXED_100 } from '@oneaudi/unified-web-common';
import {
  NextBestActionsButtonContainer,
  TextColorWrapper,
  TextWrapper,
} from './NextBestActions.styles';
import { Text, TextLink } from '@oneaudi/unified-web-components';
import { useServicesContext } from '@oneaudi/vtp-shared';
import { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';
import { useFavorites } from '../../hooks/useFavorites';
import { trackFavourizeClick } from '../tracking/Tracking';

interface FavoriteButtonProps {
  vehicleId: string;
}

export const FavoriteButton: React.FC<FavoriteButtonProps> = ({ vehicleId }) => {
  const { getAdditionalService } = useServicesContext();
  const { isFavorite, changeFavoriteStatus } = useFavorites(vehicleId);
  const trackingService = getAdditionalService('audi-tracking-service') as TrackingServiceV2;
  const keys = {
    addToFavorites: {
      label: useI18n({
        defaultMessage: 'Add to Favorites',
        id: 'stockcars.button.favourites.is-not-saved.label',
      }),
      description: useI18n({
        defaultMessage: '',
        id: 'stockcars.button.favourites.is-not-saved.description',
      }),
      ariaLabel: useI18n({
        defaultMessage: 'Add this vehicle to your list of favorites',
        id: 'stockcars.button.favourites.is-not-saved.arialabel',
      }),
    },
    removeFromFavorites: {
      label: useI18n({
        defaultMessage: 'Remove from Favorites',
        id: 'stockcars.button.favourites.is-saved.label',
      }),
      description: useI18n({
        defaultMessage: '',
        id: 'stockcars.button.favourites.is-saved.description',
      }),
      ariaLabel: useI18n({
        defaultMessage: 'Remove vehicle from your favorites list',
        id: 'stockcars.button.favourites.is-saved.arialabel',
      }),
    },
  };
  const label = isFavorite ? keys.removeFromFavorites.label : keys.addToFavorites.label;
  const ariaLabel = isFavorite ? keys.removeFromFavorites.ariaLabel : keys.addToFavorites.ariaLabel;
  const description = isFavorite
    ? keys.removeFromFavorites.description
    : keys.addToFavorites.description;
  return (
    <NextBestActionsButtonContainer>
      <TextLink
        variant="standalone"
        icon={isFavorite ? 'favorite-active' : 'favorite'}
        onClick={() => {
          trackFavourizeClick(
            trackingService,
            label,
            isFavorite ? 'vtp remove from favorites' : 'vtp add to favorites'
          );
          changeFavoriteStatus();
        }}
        iconPosition="leading"
        size="md"
        aria-label={ariaLabel}
        margin={[0, 0, SYS_SPACE_FIXED_100, 0]}
      >
        {label}
      </TextLink>
      <TextWrapper>
        <Text
          variant={{
            type: 'copy',
            order: '2',
            style: 'normal',
          }}
          tag="p"
        >
          <TextColorWrapper>{description}</TextColorWrapper>
        </Text>
      </TextWrapper>
    </NextBestActionsButtonContainer>
  );
};
